<template>
  <v-container class="d-flex flex-column align-center justify-center" style="height: 100vh;">
    <v-icon size="80" color="red darken-2">mdi-alert-circle</v-icon>
    <h1 class="text-h4 font-weight-bold mt-4">Lo sentimos</h1>
    <p class="text-subtitle1">No encontramos la página que buscabas.</p>

    <v-btn color="primary" class="mt-4" @click="$router.push('/Home')">
      Volver al inicio
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "NotFound",
  mounted() {
    const usuario = JSON.parse(sessionStorage.getItem("usuario"));
    setTimeout(() => {
      if (usuario) {
        this.$router.push("/inicio");
      } else {
        this.$router.push("/");
      }
    }, 2000);
  }
}
</script>